import { createFileRoute, redirect } from '@tanstack/react-router';
import { Layout } from '@/component/Layout';
import { returningTo, toSignIn } from '@/lib/destination';

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    const account = context.account();
    if (!account) throw toSignIn(location);
    if (account.onboardedAt === undefined) {
      throw redirect({ to: '/welcome', search: returningTo(location), replace: true });
    }
  },
  component: Layout,
});
